import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import persist from '@alpinejs/persist';

// splide
import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

window.splides = {};
document.querySelectorAll('.splide').forEach( (s,index) => {
    let splide = new Splide(s);
    // splide.mount();
    window.splides[index] = splide;
    s.dataset.splideId = index;
})

window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(persist);

// window.App = Object.assign(window.App !== undefined ? window.App : {}, {});

Alpine.start();

Object.values(window.splides).forEach( (s) => {
    s.mount();
})
